export default {
  no: {
    'Go to advertiser': 'Gå til annonsør',
    'Settings': 'Innstillinger',
    'Subtitles': 'Undertekster',
    'Off': 'Av',
    'Auto': 'Automatisk',
    'Cancel': 'Avbryt',
    'Starts in': 'Starter om {{time}}',
    'Go to next': 'Gå til neste',
    'Watch again': 'Se på nytt',
    'Live': 'Direkte',
    'LIVE': 'DIREKTE',
    'Tap to see': 'Trykk for å se',
    'More videos': 'Flere videoer',
    'More episodes': 'Flere episoder',
    'Loading ...': 'Laster ...',
    'Reload': 'Last på nytt',
    'Try again': 'Prøv igjen',
    'Reconnecting...': 'Kobler til igjen...',
    'Something went wrong': 'Noe gikk galt',
    'Sign in': 'Logg inn',
    'Buy subscription': 'Kjøp {{subscription}}',
    'Watch with subscription': 'Se med {{subscription}}',
    'Switch to subscription': 'Bytt til {{subscription}}',
    'Watch now with subscription': 'Se nå med {{subscription}}',
    'tomorrow': 'i morgen',
    'today': 'i dag',
    'yesterday': 'i går',
    'Sent': 'Sendes',
    'Coming': 'Kommer',
    'Playing at': 'Spiller på {{device}}',
    'Skip': 'Hopp over',
    'Skip with subscription': 'Hopp over med {{subscription}}',
    'Season': 'Sesong',
    // Bank ID verification
    'You are abroad': 'Ups! Vi ser du ikke er i Norge',
    'Verification message':
      'Du kan likevel se innholdet ved å verifisere deg med Bank ID',
    'Verify with BankID': 'Verifiser med Bank ID',
    'Next clip': 'Neste klipp',
    'advertisement': 'Annonse',
    'Watch from beginning': 'Se fra start',
    'Watch live': 'Se direkte',
    'Report issue': 'Rapporter problem',
    "It looks like we're having issues.": 'Det ser ut som vi har problemer.',
    "Our team has been notified. If you'd like to help, tell us what happened below.":
      'Teamet vårt har blitt varslet. Hvis du vil hjelpe, fortell oss hva som skjedde nedenfor.',
    'Send feedback': 'Send tilbakemelding til VGTV',
    'Name': 'Navn',
    'What happened?': 'Hva skjedde?',
    'Send': 'Send',
    'I clicked "X" and then "Confirm"':
      'Jeg klikket på "X" og deretter "Bekreft"',
    'See soon with': 'Se snart med {{subscription}}',
    'Error code': 'Feilkode',
    'Reference ID': 'Referanse-ID',
    'The voice reading this article is generated using artificial intelligence.':
      'Stemmen som leser denne artikkelen, er laget ved hjelp av kunstig intelligens.',
    'Read more here.': 'Les mer her.',
    'Listen to the article': 'Lytt til artikkelen',
    'Subscribe to listen': 'Abonner for å lytte',
    'min': 'min',
    'Related videos': 'Relaterte videoer',
    'Feedback': 'Tilbakemelding',
    'Captions': 'Undertekster',
    'Play': 'Spill av',
    'Report': 'Rapporter',
    'See more': 'Se mer',
    'Your playback session has expired.':
      'Avspillingsøkten din har utløpt. Vennligst oppdater siden og prøv igjen.',
    "Your browser doesn't support playback of this content.":
      'Nettleseren din støtter ikke avspilling av dette innholdet.',
    "We couldn't verify your playback rights.":
      'Vi kunne ikke verifisere avspillingsrettighetene dine. Vennligst oppdater siden og prøv igjen.',
    'Quality': 'Kvalitet',
  },
  se: {
    'Go to advertiser': 'Gå till annonsören',
    'Settings': 'Inställningar',
    'Subtitles': 'Undertexter',
    'Off': 'Av',
    'Auto': 'Automatisk',
    'Cancel': 'Avbryt',
    'Starts in': 'Startar om {{time}}',
    'Go to next': 'Gå till nästa',
    'LIVE': 'LIVE',
    'Tap to see': 'Tryck för att se',
    'More videos': 'Fler videor',
    'More episodes': 'Fler avsnitt',
    'Loading ...': 'Laddar ...',
    'Reload': 'Ladda om',
    'Try again': 'Försök igen',
    'Reconnecting...': 'Återansluter...',
    'Something went wrong': 'Något gick fel',
    'Sign in': 'Logga in',
    'Buy subscription': 'Köp {{subscription}}',
    'Switch to subscription': 'Byt till {{subscription}}',
    'Watch now with subscription': 'Titta nu med {{subscription}}',
    'Watch with subscription': 'Titta med {{subscription}}',
    'tomorrow': 'imorgon',
    'today': 'idag',
    'yesterday': 'igår',
    'Sent': 'Sänds',
    'Coming': 'Kommer',
    'Playing at': 'Spelar på {{device}}',
    'Skip': 'Hoppa över',
    'Skip with subscription': 'Hoppa över med {{subscription}}',
    'Season': 'Säsong',
    'You are abroad': 'Vi ser att du inte är i Sverige',
    'Verification message':
      'För att se innehållet från utlandet måste du identifiera dig med BankID',
    'Verify with BankID': 'Identifiera dig med BankID',
    'Next clip': 'Nästa klipp',
    'advertisement': 'Annons',
    'Watch again': 'Titta igen',
    'Report issue': 'Rapportera problem',
    "It looks like we're having issues.": 'Det ser ut som vi har problem.',
    "Our team has been notified. If you'd like to help, tell us what happened below.":
      'Vårt team har blivit notifierat. Om du vill hjälpa till, berätta vad som hände nedan.',
    'Send feedback': 'Skicka feedback till ABTV',
    'Name': 'Namn',
    'What happened?': 'Vad hände?',
    'Send': 'Skicka',
    'I clicked "X" and then "Confirm"':
      'Jag klickade på "X" och sedan "Bekräfta"',
    'See soon with': 'Se snart med {{subscription}}',
    'Error code': 'Fel kod',
    'Reference ID': 'Referens ID',
    'The voice reading this article is generated using artificial intelligence.':
      'Rösten som läser den här artikeln är skapad med hjälp av artificiell intelligens.',
    'Read more here.': 'Läs mer här.',
    'Listen to the article': 'Lyssna på artikeln',
    'Subscribe to listen': 'Prenumerera för att lyssna',
    'min': 'min',
    'Live': 'LIVE',
    'Related videos': 'Relaterade videor',
    'Feedback': 'Återkoppling',
    'Captions': 'Undertexter',
    'Play': 'Spela',
    'Report': 'Rapportera',
    'See more': 'Se mer',
    'Your playback session has expired.':
      'Din uppspelningssession har gått ut. Vänligen uppdatera sidan och försök igen.',
    "Your browser doesn't support playback of this content.":
      'Din webbläsare stöder inte uppspelning av detta innehåll.',
    "We couldn't verify your playback rights.":
      'Vi kunde inte verifiera dina uppspelningsrättigheter. Vänligen uppdatera sidan och försök igen.',
    'Quality': 'Kvalitet',
  },
};
